/** https://bootstrap-datepicker.readthedocs.io/en/stable */
<script>
	import _ from "lodash";
	import moment from "moment";

	export default {
		props: {
			value: { type: [String, Boolean], require: false, default: false },
			dates: { type: Array, require: false, default: [] }
		},
		data() {
			return {
				id: "date-picker_" + _.uniqueId(),
				selected: this.value
			};
		},
		watch: {
			selected(data) {
				this.$emit("input", data);
			}
		},
		mounted() {
			$(() => {
				$("#" + this.id)
					.datepicker({
						language: "es",
						endDate: this.endDate,
						startDate: this.startDate,
						multidate: this.multidate,
						beforeShowDay: this.beforeShowDay
					})
					.on("changeDate", this.changeDate);

				if (this.selectDate) {
					$("#" + this.id).datepicker("setDate", this.selectDate);
				}
			});
		},
		methods: {
			beforeShowDay(date) {
				if (this.dates.length > 0) {
					let fecha = moment(date).format("YYYY-MM-DD");
					return this.dates.indexOf(fecha) > -1 ? true : false;
				}
				return false;
			},
			changeDate(event) {
				this.selected = moment(event.date).format("YYYY-MM-DD");
			}
		},
		computed: {
			selectDate() {
				if (this.value !== false) {
					return moment(this.value).toDate();
				}
				return null;
			},
			startDate() {
				if (this.dates.length > 0) {
					return moment(this.dates[0]).toDate();
				}
				return false;
			},
			endDate() {
				if (this.dates.length > 0) {
					return moment(this.dates[this.dates.length - 1]).toDate();
				}
				return false;
			}
		}
	};
</script>

<template>
	<div class="date-picker-calendar" v-bind:id="id" :data-date="selectDate"></div>
</template>

<style lang="scss">
	.date-picker-calendar {
		.datepicker-inline {
			width: auto;
			font-family: monospace;
			text-transform: uppercase;
			.table-condensed {
				width: 100%;
				thead {
					tr {
						th.next,
						th.prev {
							display: none;
						}
						&:nth-child(2) {
							&::after,
							&::before {
								display: table-cell;
								content: "";
							}
						}
					}
				}
				tbody {
					tr td.disabled,
					tr td.disabled:hover {
						color: rgba(119, 119, 119, 0.4);
					}
				}
			}
		}
	}
</style>



